module.exports = __webpack_public_path__ + "media/src/images/web/sujet-imprint-ca4f52b6c09109cdec4ed9562b5e4fae.svg";